import {FailedRequestPayload, AxiosError} from '../types';
import {Action} from '../../actions';

export const ActionTypes = {
  FETCH_FEATURE_TOGGLES_PENDING: 'features/fetch_PENDING',
  FETCH_FEATURE_TOGGLES_FULFILLED: 'features/fetch_FULFILLED',
  FETCH_FEATURE_TOGGLES_REJECTED: 'features/fetch_REJECTED'
};

export interface FeatureTogglesStatusState {
  loadingFeatureToggles: boolean;
  fetchedFeatureToggles: boolean;
  featureTogglesError?: AxiosError | null;
}

export interface FeatureTogglesState extends FeatureTogglesStatusState {
  [name: string]: any | null;
}

export interface FetchFeaturesFulfilledPayload {
  [name: string]: boolean | null;
}

interface FetchFeaturesFulfilledAction extends Action<FetchFeaturesFulfilledPayload> {
  type: string;
  payload: FeatureTogglesState;
}

interface FetchFeaturesRejectedAction extends Action<FailedRequestPayload> {
  type: string;
  payload: FailedRequestPayload;
}

export interface IwhiPpcState {
  showIwhiPPCMessage: boolean;
}

export interface screenerPageState {
  enableIWhiScreenerPage: boolean;
}

export type FeatureTogglesActionTypes = FetchFeaturesFulfilledAction | FetchFeaturesRejectedAction;
